export const NOT_COURSEWARE_ITEM = 'Not Courseware Item';
export const STAGE_BRANCHES = ['sections', 'rows', 'columns', 'stageElements'];
export const SERIALIZE = 'serialize';
export const STAGE = 'stage';
export const IMAGE_URN_REGEX = /urn:(alfresco|external|aero):[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/g;

